module.exports = __webpack_public_path__ + "img/facebook.2cb400d9.svg";